import { TaskQueue } from "../../../core/_shared/models/task-queue.model";
import { ICollectionReference } from '../database-cast/IDatabase';


export class DbTasksQueue {


    private _collection: ICollectionReference;

    constructor( collection: ICollectionReference) {
        this._collection = collection;
    }

    public addTask(task:TaskQueue):Promise<TaskQueue>
    {
        let promise = new Promise<TaskQueue>((resolve, reject) => {
            this._collection.add((Object.assign({}, task)))
                .then(docReference => {
                    task.id = docReference.id;
                    resolve(task);
                }).
                catch(error=>
                    {
                        reject(error);
                        
                    });
        });


        return promise;
    }
}